export default "__VITE_ASSET__CbpwkWyI__"